import { selectedCreditorId } from '../internal.js';
const _KEY = 'caseFilter';
export const persistFiltersToLocalStorage = (tenantId, caseFilter) => {
    const savedFilters = JSON.parse(localStorage.getItem(_KEY) || '{}');
    const newFilter = {
        ...savedFilters,
        [tenantId]: caseFilter,
    };
    localStorage.setItem('caseFilter', JSON.stringify(newFilter));
};
export const getFilterFromLocalStorage = (tenantId) => {
    const savedFilters = JSON.parse(localStorage.getItem(_KEY) || '{}');
    const isFilterEmpty = Object.keys(savedFilters).length === 0 || !savedFilters[tenantId];
    // If filter is empty, we need to instantiate it with the selected creditor
    // Creditor-web is dependant on the selected creditor to show the correct data
    // TODO: Remove this when we have a better solution
    return isFilterEmpty
        ? {
            creditorIds: selectedCreditorId ? [selectedCreditorId] : [],
        }
        : savedFilters[tenantId];
};
//# sourceMappingURL=localStorage.js.map